export default[
    {
        path: '/declaracao/suspencao/trabalhador/avulso/cadastro',
        name: 'cadastro de suspenção do trabalhador avulso', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/declaracao/suspencao/trabalhador/avulso/lista',
        name: 'lista de suspenção do trabalhador avulso', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/declaracao/suspencao/trabalhador/avulso/editar/:id',
        name: 'editar suspenção do trabalhador avulso', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]